exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.guide-bind-card-dialog[data-v-deec12ce]{width:80vw;border-radius:2.66667vw;padding:8vw 5.33333vw;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.guide-bind-card-dialog .text[data-v-deec12ce]{font-family:PingFangSC-Regular;font-size:3.73333vw;color:#151515;margin-bottom:5.86667vw;line-height:6.4vw\n}\n.guide-bind-card-dialog .common-btn[data-v-deec12ce]{font-weight:600\n}\n", ""]);

// exports
